import { render, staticRenderFns } from "./PhysicalAddressField.vue?vue&type=template&id=57a9961e&"
import script from "./PhysicalAddressField.vue?vue&type=script&lang=js&"
export * from "./PhysicalAddressField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports